<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
      v-if="titleRoute != null && titleRoute != 'Login' && titleRoute != 'Empty'"
    >
      <v-app-bar-nav-icon v-if="!getDrawer()" @click="openMenu"></v-app-bar-nav-icon>
      <v-btn icon v-else @click="openMenu">
        <v-icon>mdi-backburger</v-icon>
      </v-btn>

      <div class="d-flex align-center"></div>

      <v-toolbar-title>Simjob</v-toolbar-title>
      <v-spacer></v-spacer>
      
      <v-toolbar-items>
        <btn-a
          tooltip="Kanban"
          appbar
          :access="[$access.kanban.show, $access.kanban.edit]"
          @click="navigateKanban"
          color="primary"
        >
          <v-icon>mdi-cards-variant</v-icon>
        </btn-a>

        <btn-a
          :tooltip="$tc('entities.reg.title', 2)"
          appbar
          class="mr-2"
          :access="[$access.reg.show, $access.reg.edit]"
          @click="navigateRegistry"
          color="primary"
          ><v-icon>mdi-checkbox-marked-outline</v-icon></btn-a
        >

<!--
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on"> Button </v-btn> -->

           <!-- <v-btn text @click="logout" v-on="on" v-bind="attrs">
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("logout") }}</span>
        </v-tooltip>
        -->

        <v-btn
          v-if="isTriggers"
          elevation="0"
          appbar
          @click="drawerActionOpen = !drawerActionOpen"
          color="primary"
        >
          <v-icon>mdi-flash</v-icon>
        </v-btn>

        <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list style="cursor:pointer">
          <v-list-item>
            <v-list-item-title text @click="logout">
              <v-icon style="margin-right:10px;">mdi-logout</v-icon>
              <span>{{ $t("logout") }}</span>
              </v-list-item-title>     
          </v-list-item>
        </v-list>
        
      </v-menu>


      </v-toolbar-items>
    </v-app-bar>
    <div v-else></div>
    <drawerDefault ref="drawer" />
    <drawerAction v-if="this.$route.name != 'Login'" v-model="drawerActionOpen" ref="drawerAction" />
    <v-content
      @click.native="
        $root.$emit('openDrawer', false);
        $root.$emit('click-content', false);
      "
    >
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import drawerDefault from "@/components/drawers/drawerDefault";
import drawerAction from "@/components/drawers/drawerAction";
export default {
  name: "App",

  components: {
    drawerDefault,
    drawerAction,
  },

  data: () => ({
    title: "",
    loading: false,
    drawerActionOpen: false,
    isTriggers: false,
  }),
  computed: {
    titleRoute() {
      return this.$route.name;
    },
  },
  methods: {
    getDrawer() {
      return this.$refs.drawer.drawer;
    },
    navigateRegistry() {
      this.$router.push({
        name: "Registry Resource"
      });
    },
    navigateKanban() {
      this.$router.push({
        name: "Kanban",
      });
    },
    async logout() {
      let res = await this.$auth.logout();
      if (res.success)
        this.$router.push({
          name: "Login",
        });

    },
    openMenu() {
      this.isTriggers = this.$auth.isTriggers();
      this.$root.$emit("openDrawer");
    },
  },
  async mounted() {
    this.isTriggers = this.$auth.isTriggers();
    let locale = await this.$getItem("simjob_locale");
    if (locale == null) this.$setItem("simjob_locale", this.$i18n.locale);
    else this.$i18n.locale = locale;


  },
  created() {
    this.$bus.$on("changeTitle", (value) => {
      this.title = value;
    });
  },
};
</script>
